// src/components/sessions/EmailPreviewModal.js
import React from 'react';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, Divider } from '@mui/material';

// The visual representation of the email
const EmailContent = ({ prospect, session }) => {
    // This component will not render if the necessary data isn't available.
    if (!prospect || !session) return null;

    const isDirectMatch = prospect.matchType === 'direct';
    const firstName = prospect.name.split(' ')[0];
    const phoneDigits = (prospect.phone || '').replace(/\D/g, '');
    const preferencesLink = `https://academy.marsreel.com/preferences/${phoneDigits}`;

    // --- CRITICAL FIX: Correct the URL structure ---
    const sessionLink = `https://academy.marsreel.com/event.html?id=${session._id}`;

    // This function prevents links from being followed in the preview
    const preventNavigation = (e) => {
        e.preventDefault();
        // You could show an alert here like: alert("This is a preview. Links are not active.");
    };

    return (
        <Box sx={{ fontFamily: 'Arial, sans-serif', color: '#333', lineHeight: 1.6, backgroundColor: '#ffffff', p: 3, borderRadius: '8px' }}>
            <Typography variant="h5" component="h1" sx={{ color: '#1a1a1a', fontWeight: 'bold', mb: 3 }}>
                Sessions Recommended For You
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
                Hey {firstName},
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
                {isDirectMatch ? "Based on the preferences you shared with us, we think you'll love this upcoming session in your area:" : (
                    <>You haven't shared your training preferences yet (you can update them{' '}
                        <a href={preferencesLink} onClick={preventNavigation} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'none', fontWeight: 'bold' }}>here</a>), but based on interest from others near you, we think you'll love this session:</>
                )}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ border: '1px solid #ddd', p: 2, borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
                <a href={sessionLink} onClick={preventNavigation} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                    {session.venueImage1 && <img src={session.venueImage1} alt={session.name} style={{ maxWidth: '100%', height: 'auto', borderRadius: '5px', display: 'block' }}/>}
                    <Typography variant="h6" component="h2" sx={{ mt: 2, mb: 1, color: '#1a1a1a', fontWeight: 'bold' }}>
                        {session.name}
                    </Typography>
                </a>
                <Typography variant="body2"><strong>When:</strong> {new Date(session.eventDate).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</Typography>
                <Typography variant="body2"><strong>Where:</strong> {session.address}</Typography>

                <Button variant="contained" disabled sx={{ mt: 2, backgroundColor: '#007bff', '&:hover': { backgroundColor: '#0056b3' }, textTransform: 'none', fontWeight: 'bold' }}>
                    View Details & Register
                </Button>
            </Box>

            <Divider sx={{ my: 2 }} />

        </Box>
    );
};

// The modal that wraps the email content (No changes needed here)
const EmailPreviewModal = ({ open, onClose, prospect, session }) => {
    const darkBg = '#2a2a2e';
    const lightText = '#f9f9f9';
    const borderColor = '#444';

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ backgroundColor: darkBg, color: lightText, borderBottom: `1px solid ${borderColor}` }}>
                Email Preview for: {prospect?.name}
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: '#f0f0f0', p: { xs: 1.5, sm: 2 } }}>
                <EmailContent prospect={prospect} session={session} />
            </DialogContent>
            <DialogActions sx={{ backgroundColor: darkBg, color: lightText, borderTop: `1px solid ${borderColor}` }}>
                <Button onClick={onClose} sx={{ color: lightText, textTransform: 'none' }}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EmailPreviewModal;
